"use client";

import createIcon from './util/createIcon';
export default createIcon('M19,4H15L7.1,16.63L4.5,12L9,4H5L0.5,12L5,20H9L16.89,7.37L19.5,12L15,20H19L23.5,12L19,4Z', 'Polymer');